export default class User {
    id: string = "";
    name: string = "";
    email: string = "";
}
